import './bootstrap';
import '../scss/app.scss';

import {createApp, h} from 'vue';
import * as Sentry from "@sentry/vue";
import {createInertiaApp} from '@inertiajs/vue3';
import {resolvePageComponent} from 'laravel-vite-plugin/inertia-helpers';
import {ZiggyVue} from '../../vendor/tightenco/ziggy/dist/vue.m';
import {i18nVue} from "laravel-vue-i18n";
import { plugin as VueTippy } from 'vue-tippy'
import 'tippy.js/dist/tippy.css'
import moment from "moment"; // optional for styling
import 'moment/dist/locale/ro'
const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({el, App, props, plugin}) {
        el.classList.add('h-full') // <---
        const app = createApp({render: () => h(App, props)});

        /// global locale
        const language = document.documentElement.lang;
        app.config.globalProperties.$moment = moment;
        app.config.globalProperties.$moment.locale(language);

        Sentry.init({
            app: app,
            dsn: import.meta.env.VITE_SENTRY_DSN,
            trackComponents: true,
            debug: import.meta.env.VITE_APP_DEBUG === 'true',
            integrations: [
                Sentry.browserTracingIntegration(),
                Sentry.replayIntegration({
                    maskAllText: false,
                    blockAllMedia: false,
                }),
            ],
            environment: import.meta.env.VITE_APP_ENV,
            tracesSampleRate: import.meta.env.VITE_APP_ENV === 'production' ? 0.1 : 1.0,
            tracePropagationTargets: ["https://seeo2.app", "https://seeo2-v2.test", "localhost"],
            replaysSessionSampleRate: import.meta.env.VITE_APP_ENV === 'production' ? 0.1 : 1.0,
            replaysOnErrorSampleRate: 1.0,
        });
        app.use(plugin)
            .use(VueTippy)
            .use(ZiggyVue)
            .use(i18nVue, {
                resolve: async lang => {
                    const langs = import.meta.glob('../../lang/*.json');
                    const key = `../../lang/php_${lang}.json`;
                    if (!langs[key]) {
                        console.warn(`[i18n] Missing lang file for "${lang}", falling back to "ro"`);
                        return await langs['../../lang/php_ro.json']();
                    }
                    return await langs[key]();
                },
                onLoad:() => {
                    app.mount(el)
                }
            })

        // throw test error but continue
        // throw new Error('Test error');

        return app;
    },
    progress: {
        color: '#4B5563',
    },
});
